import React from 'react';
import clsx from 'clsx';
import { Container } from 'semantic-ui-react';
import AnnouncementContent from './AnnouncementContent';
import AnnouncementNav from './AnnouncementNav';
import AnnouncementDismiss from './AnnouncementDismiss';
import Selectors from '../hooks/selectors';
import Fetch from '../hooks/fetch';

const AnnouncementContainer = () => {
  const state = Selectors.useAnnouncementContainer();
  Fetch.useFetchAnnouncements({ category: 'all' }, state.readStatus);
  if (!state.showAnnouncements || state.hideForSession || state.fullscreen) return null;

  return (
    <div className={clsx('aridhia-notification-container h-100', `aridhia-theme-${state.theme}`)}>
      <Container>
        <div className="flex items-center justify-center m-6">
          <div className="ui icon primary message small w-90 p-8 h-60 aridhia-announcements-hover z-101">
            <AnnouncementContent />
            <AnnouncementNav />
            <AnnouncementDismiss />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default AnnouncementContainer;
